<template>
  <section class="opt-card opt-card--accent">
    <label class="opt-card__row">
      <v-checkbox
        v-model="mitClearment"
        color="primary"
        density="comfortable"
        hide-details
        class="opt-card__check"
      />
      <div class="opt-card__main">
        <div class="opt-card__brand">
          <img
            :src="require('@/assets/clearmentai/clearmentai.png')"
            alt="Clearment"
            class="opt-card__logo"
          />
          <span class="opt-card__free">kostenlos</span>
        </div>
        <div class="opt-card__title">Clearment Vertragsschutz</div>
        <p class="opt-card__sub">
          Bei Abschluss über uns erhalten Sie den Clearment Vertragsschutz
          <strong>kostenlos</strong>.
          <a
            class="opt-card__link"
            @click.prevent="showClearment = !showClearment"
          >
            Vorteile anzeigen →
          </a>
        </p>
      </div>
      <img
        v-if="!sharedDataStore.isMobile()"
        :src="require('@/assets/clearmentai/plus.png')"
        class="opt-card__img"
        alt="Clearment Plus"
      />
    </label>

    <v-dialog v-model="showClearment" width="1111" rounded="0" scrollable>
      <v-card class="pa-4" rounded="0">
        <ClearmentSchutz />
      </v-card>
    </v-dialog>
  </section>
</template>

<script setup>
  import { ref, defineEmits, watch } from "vue";
  import ClearmentSchutz from "@/components/tarif/info/ClearmentSchutz";
  import { useSharedDataStore } from "@/stores/sharedData";
  const sharedDataStore = useSharedDataStore();

  const emit = defineEmits(["updatedClearment"]);

  const showClearment = ref(false);
  const mitClearment = ref(true);
  watch(mitClearment, (newValue) => {
    emit("updatedClearment", newValue);
  });
</script>

<style scoped>
  .opt-card {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-radius: 3px;
  }
  .opt-card--accent {
    border-left: 3px solid #0f4c81;
  }
  .opt-card__row {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 6px 14px;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    margin: 0;
  }
  .opt-card__check {
    flex: 0 0 auto;
  }
  .opt-card__check :deep(.v-selection-control) {
    min-height: auto;
  }
  .opt-card__check :deep(.v-icon) {
    font-size: 26px;
    opacity: 1;
  }
  .opt-card__main {
    min-width: 0;
  }
  .opt-card__brand {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 2px;
  }
  .opt-card__logo {
    height: 18px;
    width: auto;
    display: block;
  }
  .opt-card__title {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.25;
  }
  .opt-card__free {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #ffffff;
    background: #2e7d32;
    padding: 2px 7px;
    border-radius: 3px;
  }
  .opt-card__sub {
    margin: 4px 0 0;
    font-size: 13.5px;
    color: #4b5563;
    line-height: 1.5;
  }
  .opt-card__link {
    color: #0f4c81;
    font-weight: 600;
    margin-left: 2px;
    cursor: pointer;
    text-decoration: none;
  }
  .opt-card__link:hover {
    text-decoration: underline;
  }
  .opt-card__img {
    height: 56px;
    width: auto;
    object-fit: contain;
    opacity: 0.95;
  }

  @media (max-width: 720px) {
    .opt-card__row {
      grid-template-columns: auto 1fr;
      gap: 6px 10px;
      padding: 10px 12px;
    }
    .opt-card__img {
      display: none;
    }
  }
</style>
